import ExpiresAfterElement from "./ExpiresAfter/ExpiresAfterElement.tsx";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useEffect } from "react";
import { useSaveUploadingMail } from "../Helpers/useSaveUploadingMail.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const SaveMailComponent = ({ item, externalProps }) => {
  // if item exist its mean compoonent using in form
  const { saved } = useSaveUploadingMail();
  const { getUploading } = useUploader();

  //saving value to body
  useEffect(() => {
    if (externalProps?.setBody && item) {
      externalProps.setBody((prevBody) => ({
        ...prevBody,
        [item.fieldKey]: saved,
      }));
    }
  }, [saved]);

  if (!item && getUploading()) return null;

  return (
    <div className={`save-mail-elem${item ? " security-option" : ""}`}>
      <ExpiresAfterElement isSettingItem />
      <Icon name="timer" gray iconClass="security-option-icon" />
    </div>
  );
};
export default SaveMailComponent;
